<template>
  <el-dialog
    v-model="visible"
    class="tier-confirm"
    width="440px"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
  >
    <h3 class="tier-confirm-title">{{ title }}</h3>
    <ul class="tier-confirm-list" v-if="lines.length">
      <li v-for="(line, index) in lines" :key="index">{{ line }}</li>
    </ul>

    <template #footer>
      <span class="tier-confirm-no" @click="$emit('cancel')">No</span>
      <Button color="dark-blue" size="32" :border_r="6" :is_disabled="is_busy" @click="$emit('confirm')">
        {{ confirm_text }}
      </Button>
    </template>

    <Loading class="absolute" v-if="is_busy" />
  </el-dialog>
</template>

<script>
import { ElDialog } from 'element-plus';
import Button from '@/components/ui/Button.vue';
import Loading from '@/components/ui/Loading.vue';

export default {
  name: 'TierConfirm',

  components: { ElDialog, Button, Loading },

  props: {
    is_show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    // optional bullet list spelling out what is about to change
    lines: {
      type: Array,
      default: () => [],
    },
    confirm_text: {
      type: String,
      default: 'Confirm',
    },
    // true while the caller's request is in flight
    is_busy: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['cancel', 'confirm'],

  computed: {
    visible: {
      get() {
        return this.is_show;
      },
      set(val) {
        if (val || this.is_busy) return;
        // el-dialog only reports the close once its leave transition ends (afterLeave), so a
        // close the caller already asked for comes back here as a spurious cancel. When the
        // prop is still true nobody asked, which means it was ESC: the only real cancel.
        if (this.is_show) this.$emit('cancel');
      },
    },
  },
};
</script>
<style lang="scss">
.tier-confirm {
  border-radius: 12px;

  // no title bar, the heading lives in the body
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 24px 24px 0;
  }

  .el-dialog__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 24px;
  }

  .tier-confirm-title {
    font: var(--font-med-20);
    color: var(--black-90);
  }

  .tier-confirm-list {
    margin: 16px 0 0;
    padding-left: 18px;

    li {
      list-style: disc;
      color: var(--black-75);
      line-height: 22px;
    }
  }

  .tier-confirm-no {
    padding: 0 12px;
    color: var(--black-90);
    cursor: pointer;

    &:hover {
      color: var(--blue);
    }
  }
}
</style>
